export default {
  props: {

  },
  data() {
    return {
      slotBodyHeight: '-1px',
      screenHeight: document.body.clientHeight,
      screenWidth: document.body.clientWidth,
      timer: false,
    }
  },
  watch: {
    screenHeight(val) {
      if(!this.timer) {
        this.screenHeight = val
        this.slotBodyHeight = this.screenHeight - 276 + "px";
        this.timer = true
        let that = this
        setTimeout(function() {
          that.timer = false
        }, 400)
      }
    },
    screenWidth(val) {
      if(!this.timer) {
        this.screenWidth = val
        this.timer = true
        let that = this
        setTimeout(function() {
          that.timer = false
        }, 400)
      }
    }
  },
  mounted() {
    const that = this
    const height = document.documentElement.clientHeight || document.body.clientHeight;   //滚动区域的高=屏幕高-header高-footer高
    this.slotBodyHeight = (height - 276) + 'px'
    window.onresize = () => {
      return (() => {
        window.screenHeight = document.body.clientHeight
        window.screenWidth = document.body.clientWidth
        that.screenHeight = window.screenHeight
        that.screenWidth = window.screenWidth
      })()
    }
  },
}


// WEBPACK FOOTER //
// ./src/mixins/drawer.js